import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, map} from 'rxjs/operators';

import {IsEmptyString, IsEmptyVar} from '../../defines/common.func';
import {PAGE, PROVERB_API_URL, PROVERB_DETAIL_API_URL} from '../../defines/protocol';
import {SearchParam} from '../../defines/client.const';
import {Proverb} from '../../models/proverb.model';
import {ListLoader, ListLoader_NextList} from '../../interfaces/list-loader';
import {ApiService} from '../api/api.service';
import {NormalizeSearchKeyword} from '../../defines/search-keyword.func';

@Injectable({
  providedIn: 'root'
})
export class ProverbService implements ListLoader<Proverb> {
  protected urlApi = PROVERB_API_URL;

  protected totalCount: number;
  protected pageSize: number;
  protected listProverb: Array<Proverb>;
  protected mapProverb: Map<string, Proverb>;
  protected nextUrl: string = null;
  private load$: Observable<ListLoader_NextList<Proverb>> = null;
  private loadDetail$: Observable<Proverb> = null;


  constructor(
    protected api: ApiService,
  ) { }

  protected getReadCount(): number {
    return this.pageSize;
  }

  /******************************************************************************
   * ListLoader<Proverb> 구현부
   *****************************************************************************/
  public getList(): Array<Proverb> {
    return this.listProverb;
  }
  public getCurCount(): number {
    return IsEmptyVar(this.listProverb) ? null : this.listProverb.length;
  }
  public getTotalCount(): number {
    return IsEmptyVar(this.totalCount) ? null : this.totalCount;
  }
  public IsComplete(): boolean {
    return this.totalCount === 0 ||
      (!IsEmptyVar(this.listProverb) && !IsEmptyVar(this.totalCount) && this.listProverb.length === this.totalCount);
  }
  public IsLoading(): boolean {
    return this.load$ !== null;
  }
  public getById(id: string): Proverb {
    return this.mapProverb.get(id) ?? null;
  }

  public ResetList(param: SearchParam = null): void {
    this.nextUrl = null;
    this.listProverb = null;
    this.mapProverb = null;
    this.totalCount = null;
    this.pageSize = null;

    if (param) {
      if ('index' in param) {
        this.nextUrl = this.urlApi + '?index=' + param.index;
      }else if ('keyword' in param) {
        const keyword = NormalizeSearchKeyword(param.keyword);
        if (!IsEmptyString(keyword)) {
          this.nextUrl = this.urlApi + '?search=' + keyword;
        }
      }

      if ('start' in param) {
        this.nextUrl = this.nextUrl ? this.nextUrl + '&start=' + param.start : this.urlApi + '?start=' + param.start;
      }
    }

    if (!this.nextUrl) {
      this.nextUrl = this.urlApi;
    }

    // console.error('ProverbService::ResetList()', this.urlApi, this.nextUrl);
  }

  public GetNextList(): Observable<ListLoader_NextList<Proverb>> {
    // console.warn('ProverbService::GetNextList()', this.urlApi, this.nextUrl);

    if (IsEmptyString(this.nextUrl)) {
      return throwError({error: 'No more pages in ProverbList'});
    }

    if (this.load$) {
      return this.load$;
    }

    return this.load$ = this.api.Get(this.nextUrl).pipe(
      catchError(err => {
        if ('status' in err && err.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      } ),
      map((data: PAGE) => {
        // console.log('ProverbService::GetNextList.api.Get data =', data);

        let first = false;
        if (this.totalCount === null) {
          this.totalCount = data.count;
          this.pageSize = data.page_size;
          this.listProverb = new Array<Proverb>();
          this.mapProverb = new Map<string, Proverb>();
          first = true;
        }
        else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data );
        }

        const list = new Array<Proverb>();

        // 뒤에서 useCount만큼 잘라낸다.
        const results = data.results.slice(- this.getReadCount());

        results.forEach(value => {
          const proverb = new Proverb(value);
          list.push(proverb);
          this.listProverb.push(proverb);
          this.mapProverb.set(proverb.id, proverb);
        });

        this.nextUrl = data.next;

        return {list, first};
      })
    );
  }

  /******************************************************************************
   * 상세 속담 정보 획득
   * 위쪽의 목록에는 간섭이 없도록 처리하는 것이 좋다.
   * TODO: 로딩중인 것을 처리. (예외상황 처리 추가해야 함)
   *****************************************************************************/
  // tslint:disable-next-line:variable-name
  public GetDetail(proverb_id: string): Observable<Proverb> {
    const url = PROVERB_DETAIL_API_URL + proverb_id + '/';
    console.log('ProverbService::GetDetail() url =', url);

    return this.loadDetail$ = this.api.Get(url).pipe(
      finalize(() => this.loadDetail$ = null),
      map(value => {
        const out = new Proverb(value);
        // console.log('ProverbService::GetDetail data = ', value, out);
        return out;
      })
    );
  }

}
